/**
 * Oddit replacements for the old Parallax sections (2026-10-02). No jQuery, Swiper or Alpine.
 * 1. Sliders (sections/testimonial.liquid): native scroll-snap track; the prev/next buttons
 *    scroll by one viewport of cards and only show when the track overflows.
 * 2. Related products (sections/product-recommendations.liquid): fetch the section from
 *    Shopify's recommendations endpoint, swap it in, then fire shopify:section:load so the
 *    card script (swatches, hover video) binds to the new cards. Klaviyo only draws star
 *    widgets that exist at page load, so drawStars() fills the injected cards' widgets from
 *    Klaviyo's public rating endpoint, in Klaviyo's own markup (its CSS and the zero-review
 *    hiding rule then apply unchanged).
 */
(function () {
  'use strict';

  function initSlider(root) {
    if (root.__odditSlider) return;
    root.__odditSlider = true;
    var track = root.querySelector('[data-oddit-slider-track]');
    var controls = root.querySelector('[data-oddit-slider-controls]');
    if (!track || !controls) return;
    var prev = controls.querySelector('[data-oddit-slider-prev]');
    var next = controls.querySelector('[data-oddit-slider-next]');

    function step() {
      var slide = track.querySelector('.oddit-slider__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / (slide.offsetWidth + gap)));
      return per * (slide.offsetWidth + gap);
    }
    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 4;
      controls.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var STAR_PATH = 'M11.1488 2.23197C10.7159 1.22183 9.28382 1.22183 8.85091 2.23197L6.95034 6.66662H2.67243C1.5588 6.66662 1.00109 8.01305 1.78854 8.8005L4.91029 11.9222L3.59487 17.1839C3.32787 18.2519 4.47191 19.1186 5.42772 18.5724L9.99984 15.9597L14.572 18.5724C15.5278 19.1186 16.6718 18.2519 16.4048 17.1839L15.0894 11.9222L18.2111 8.8005C18.9986 8.01304 18.4409 6.66662 17.3272 6.66662H13.0493L11.1488 2.23197Z';
  var starSeq = 0;

  function klaviyoCompany() {
    var s = document.querySelector('script[src*="klaviyo.js?company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : 'TM4dDp';
  }

  function starSvg(fill) {
    var id = 'oddit-star-' + (++starSeq);
    var pct = Math.round(Math.max(0, Math.min(1, fill)) * 100) + '%';
    return '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" class="kl_reviews__full_star" style="width: 20px; height: 20px; display: inline-block;">' +
      '<defs><linearGradient id="' + id + '">' +
      '<stop offset="0%" stop-color="#F8BE00" class="kl_reviews__star--fill"></stop>' +
      '<stop offset="' + pct + '" stop-color="#F8BE00" class="kl_reviews__star--fill"></stop>' +
      '<stop offset="' + pct + '" stop-color="#E5E5E5" class="kl_reviews__star--empty"></stop>' +
      '<stop offset="100%" stop-color="#E5E5E5" class="kl_reviews__star--empty"></stop>' +
      '</linearGradient></defs><path fill="url(#' + id + ')" stroke-width="2" stroke-linejoin="round" d="' + STAR_PATH + '" class="kl_reviews__star"></path></svg>';
  }

  function drawStars(scope) {
    var els = Array.prototype.filter.call(
      scope.querySelectorAll('.klaviyo-star-rating-widget[data-id]'),
      function (el) { return el.childElementCount === 0; }
    );
    if (!els.length) return;
    var ids = [];
    els.forEach(function (el) {
      var pid = el.getAttribute('data-id');
      if (pid && ids.indexOf(pid) === -1) ids.push(pid);
    });
    var url = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/?company_id=' + klaviyoCompany() +
      '&products=' + encodeURIComponent(JSON.stringify(ids));
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products) return;
        var byId = {};
        data.products.forEach(function (p) { byId[String(p.external_id || p.shopify_id)] = p; });
        els.forEach(function (el) {
          if (el.childElementCount) return;
          var p = byId[el.getAttribute('data-id')];
          var rating = p ? Number(p.star_rating) || 0 : 0;
          var count = p ? Number(p.review_count) || 0 : 0;
          var shown = Math.round(rating * 10) / 10;
          var countText = count + (count === 1 ? ' review' : ' reviews');
          var stars = '';
          for (var i = 0; i < 5; i++) stars += starSvg(rating - i);
          el.innerHTML = '<div aria-label="' + shown + ' stars, ' + countText + '" class="kl_reviews__star_rating_widget">' +
            '<div aria-hidden="true" class="kl_reviews__stars_badge">' + stars + '</div><span> </span>' +
            '<div class="kl_reviews__star_rating_widget__label">' + countText + '</div></div>';
        });
      })
      .catch(function () {});
  }

  function initRecs(root) {
    if (root.__odditRecs) return;
    var url = root.getAttribute('data-oddit-recs-url');
    if (!url) return;
    root.__odditRecs = true;
    function load() {
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.oddit-recs');
          if (!fresh || !fresh.querySelector('.oddit-section-collection-grid__card')) return;
          root.innerHTML = fresh.innerHTML;
          root.removeAttribute('data-oddit-recs-url');
          var grid = root.querySelector('.oddit-section-collection-grid');
          if (grid) grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          drawStars(root);
        })
        .catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      load();
    }
  }

  function initAll(scope) {
    scope = scope && scope.querySelectorAll ? scope : document;
    scope.querySelectorAll('[data-oddit-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-oddit-recs-url]').forEach(initRecs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('oddit-section-collection-grid')) return;
    initAll(e.target);
  });
})();
